export default __webpack_public_path__ + "static/vitamins-supplements-promo-672d81dbad315360e215e2d6536f3b9f.jpg";